import { Box, Typography } from "@mui/material";
import TemplatePreviewCanvas from "../../Components/TemplatePreviewCanvas";

function TemplatePreview({ item, height }) {
  return item.elements ? (
    <TemplatePreviewCanvas elements={item.elements} resolution={item.resolution} />
  ) : item.imageUrl ? (
    <img src={item.imageUrl} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
  ) : (
    <Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Typography variant="caption" color="text.secondary">No preview</Typography>
    </Box>
  );
}

export default TemplatePreview;